import { FieldController } from './field.controllers';
import { FieldViewProps } from './field.model';

export const Field = (props: FieldViewProps) => {
  return <FieldController {...props} />;
};
